// extracted by mini-css-extract-plugin
module.exports = {"root":"Checkbox_root__2qQtT","title":"Checkbox_title__2c7xi","error":"Checkbox_error__1DF6w","errorMessage":"Checkbox_errorMessage__1BirL","spin":"Checkbox_spin__2K5DF"};